import { useStateMachine } from "machine/config";
import { IStateCustom } from "machine/types/types";
import {
  TCheckoutContext,
  TCheckoutEvent,
} from "containers/Checkout/machine/types";
import { TAppContext, TAppEvent } from "containers/app/machine/types";

import { AppMachine } from "containers/app/machine/state";
import { CheckOutMachine } from "containers/Checkout/machine/state";
import { ResultMachine } from "containers/Result/machine/state";
import { TResultContext, TResultEvent } from "containers/Result/machine/types";

export function MachineStore() {
  const AppState = useStateMachine<TAppContext, TAppEvent>(
    AppMachine
  ) as IStateCustom<TAppContext, TAppEvent>;
  const CheckoutState = useStateMachine<TCheckoutContext, TCheckoutEvent>(
    CheckOutMachine
  ) as IStateCustom<TCheckoutContext, TCheckoutEvent>;
  const ResultState = useStateMachine<TResultContext, TResultEvent>(
    ResultMachine
  ) as IStateCustom<TResultContext, TResultEvent>;

  const store = {
    AppState,
    CheckoutState,
    ResultState,
  };
  return store;
}

export type MachineStoreType = typeof MachineStore;
